import { POST } from '../endpoints'
import { postData } from '../utils'
import { ErrorCorrectionRequest, ErrorCorrectionResponse } from './type'

export async function errorCorrections(datasetId: string, request: ErrorCorrectionRequest) {
  return postData<ErrorCorrectionResponse, ErrorCorrectionRequest>({
    endpoint: POST.errorCorrections(datasetId),
    queryOptions: request,
  })
}
